angular.module('gym.components').controller('FutureBookingLimitsModal', ["$scope", "$rootScope", "$modalInstance", "type", function($scope, $rootScope, $modalInstance, type) {
  var gym;
  gym = $rootScope.gym;
  $scope.type = type;
  $scope.limitPlaces = function() {
    var availablePlaces, places;
    availablePlaces = _.compact(['Clubworx website', gym.member_portal_enabled && 'the member portal', gym.mobile_app_enabled && 'the mobile app']);
    places = availablePlaces.join(' or ');
    if (availablePlaces.length > 2) {
      return places.replace(' or ', ', ');
    } else {
      return places;
    }
  };
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
